module.exports = __webpack_public_path__ + "static/media/fruit-logo.e448797e.png";